export function ExtraResource({ resourceCount, resourcePerMin, leftSide, icon = "/liveGameIcons/oliveoil.png" }) {
    return (
        <div className="flex flex-row w-[84px] h-[40px] justify-center border-solid border" style={{
                backgroundImage: `url(/liveGameIcons/BACKGROUND.png)`,
                borderColor: 'var(--main-color)'
            }}>
            <div className="flex flex-col text-right gap-1">
                <div className="h-4 text-white">{parseInt(resourceCount)}</div>
                <div className="h-4 text-[#b1b1b1] italic text-xs">{parseInt(resourcePerMin)}/min</div>
            </div>
            <img className="h-8" src={icon} alt=""/>
        </div>
    )
}